export default __webpack_public_path__ + "static/media/logo.cd44a73e.svg";